import { Controller } from '@hotwired/stimulus';
import IMask from 'imask';

// The masked money field. Money#label's shape in the reader's language comes
// in as values (Money.shape: "R$ num" in pt, "R$num" in en, the marks, the
// coin's decimals) so this engine never assumes anybody's currency or
// language — AppFormBuilder#money_input writes them onto the element.
export default class extends Controller {
  static values = {
    pattern: { type: String, default: '' },
    radix: { type: String, default: ',' },
    thousands: { type: String, default: '.' },
    places: { type: Number, default: 2 },
  };

  connect() {
    if (!this.patternValue) return;

    const input = this.element;
    const maskOptions = {
      // The mask is what the eye reads; the form posts the bare number.
      // Money.from_input parses the masked shape too, but a locale-free decimal
      // on the wire is the one that cannot be read two ways.
      unmask: true,
      mask: this.patternValue,
      blocks: {
        num: {
          mask: Number,
          scale: this.placesValue,
          radix: this.radixValue,
          thousandsSeparator: this.thousandsValue,
          signed: false,
          padFractionalZeros: true,
          normalizeZeros: true,
          // Nothing maps onto the decimal mark: in pt "25.000,00" is twenty-
          // five thousand, and mapping "." to "," booked it as R$ 25,00. A
          // Brazilian numpad already types ",", so the mapping bought nothing.
          mapToRadix: [],
        },
      },
    };
    IMask(input, maskOptions);
  }
}
